var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-page-container",
      attrs: { a_id: "login-page-container", "extension-name": "login-page" }
    },
    [
      _c(
        "div",
        {
          staticClass: "login-page-header",
          attrs: { a_id: "login-page-header" }
        },
        [
          _vm.isTargetAgent
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("translate")("LoginPage.AgentLogin")) +
                    "\n\t\t"
                )
              ])
            : _c("span", [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm._f("translate")("LoginPage.LoginHeaderStart")) +
                    " "
                ),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm._f("translate")("LoginPage.LoginHeaderEnd"))
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
            }
          }
        },
        [
          _c("login-page-field", {
            attrs: {
              "input-id": "account",
              a_id: "login-page-field-accountId",
              title: _vm._f("translate")("LoginPage.AccountId"),
              placeholder: _vm._f("translate")("LoginPage.AccountId"),
              disabled: _vm.accountInputDisabled,
              "show-error-message": _vm.loginFailed
            },
            on: { enter: _vm.loginClicked },
            model: {
              value: _vm.accountId,
              callback: function($$v) {
                _vm.accountId = $$v
              },
              expression: "accountId"
            }
          }),
          _vm._v(" "),
          _c("login-page-field", {
            attrs: {
              "input-id": "username",
              a_id: "login-page-field-userName",
              title: _vm._f("translate")("LoginPage.UserName"),
              placeholder: _vm._f("translate")("LoginPage.UserName"),
              "image-type": "userName",
              "show-error-message": _vm.loginFailed
            },
            on: { enter: _vm.loginClicked },
            model: {
              value: _vm.userName,
              callback: function($$v) {
                _vm.userName = $$v
              },
              expression: "userName"
            }
          }),
          _vm._v(" "),
          _c("login-page-field", {
            attrs: {
              "input-id": "password",
              a_id: "login-page-field-password",
              title: _vm._f("translate")("LoginPage.Password"),
              type: "password",
              "show-error-message": _vm.loginFailed,
              "error-message":
                _vm.errorMessage ||
                "LoginPage.InvalidPasswordErrorMessage" | _vm.translate,
              placeholder: _vm._f("translate")("LoginPage.Password"),
              "image-type": "password"
            },
            on: { enter: _vm.loginClicked },
            model: {
              value: _vm.password,
              callback: function($$v) {
                _vm.password = $$v
              },
              expression: "password"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "login-page-footer",
              attrs: { a_id: "login-page-footer" }
            },
            [
              _vm.accountId && _vm.userName && _vm.password
                ? _c(
                    "button",
                    {
                      staticClass: "login-page-footer-button-right",
                      attrs: { a_id: "login-page-footer-login-button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.loginClicked($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm._f("translate")("LoginPage.LoginButton")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "login-page-footer-button-right",
                      attrs: {
                        disabled: "",
                        a_id: "login-page-footer-login-button-disabled"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm._f("translate")("LoginPage.LoginButton")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "login-page-footer-link",
                  attrs: { href: "#", a_id: "login-page-footer-forgot-link" },
                  on: { click: _vm.forgotPasswordClicked }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm._f("translate")("LoginPage.ForgotPasswordLink")
                      ) +
                      "\n\t\t\t"
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-becca53a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-becca53a","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/LoginSignInPage.vue
// module id = 438
// module chunks = 0